// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"35":"938222bb","119":"970ab8be","284":"f4136167","356":"874715b7","361":"aa937d2e","367":"1d79ad19","615":"616785d7","796":"fa673939"}[chunkId] + ".chunk.js";
};